import { render, staticRenderFns } from "./professionalPortrait.vue?vue&type=template&id=522baf1d&scoped=true"
import script from "./professionalPortrait.vue?vue&type=script&lang=js"
export * from "./professionalPortrait.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/popUp.scss?vue&type=style&index=0&id=522baf1d&prod&lang=scss&scoped=true&external"
import style1 from "@/assets/css/custom.scss?vue&type=style&index=1&id=522baf1d&prod&lang=scss&scoped=true&external"
import style2 from "./professionalPortrait.vue?vue&type=style&index=2&id=522baf1d&prod&lang=scss&scoped=true"
import style3 from "./professionalPortrait.vue?vue&type=style&index=3&id=522baf1d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "522baf1d",
  null
  
)

export default component.exports